var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconeCaravane(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-5 {\n        mask: url(#mask);\n      }\n\n      .cls-6 {\n        filter: url(#luminosity-invert);\n      }\n\n      .cls-7 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-8 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-9 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-10 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-11 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-3 {\n        fill: #000;\n        fill-opacity: .6;\n      }\n\n      .cls-4 {\n        fill: #ad974f;\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-invert",
    x: -378.5,
    y: -378.5,
    width: 1257,
    height: 1257,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "cm",
    values: "-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: -378.5,
    y: -378.5,
    width: 1257,
    height: 1257,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c6bf0f224f"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -378.5,
    y: -378.5,
    width: 1257,
    height: 1257
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 89.4,
    width: 500,
    height: 321.2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 120.1,
    y: 329.6,
    width: 81,
    height: 78.7
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2.4,
    y: 287.7,
    width: 240.7,
    height: 78.2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2.4,
    y: 176,
    width: 240.7,
    height: 106.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2.4,
    y: 92,
    width: 402.7,
    height: 78.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 326.8,
    y: 287.7,
    width: 170,
    height: 111.7
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M326.8,177.4h76.9v102.5h-76.9v-102.5Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M198.7,369.5c0-2.5-.2-5-.7-7.5s-1.2-4.9-2.2-7.2c-1-2.3-2.1-4.5-3.5-6.6-1.4-2.1-3-4-4.8-5.8s-3.7-3.4-5.8-4.8c-2.1-1.4-4.3-2.6-6.6-3.6-2.3-1-4.7-1.7-7.2-2.2s-5-.7-7.5-.7-5,.3-7.5.7-4.9,1.2-7.2,2.2c-2.3,1-4.5,2.1-6.6,3.6-2.1,1.4-4,3-5.8,4.8-1.8,1.8-3.4,3.7-4.8,5.8-1.4,2.1-2.6,4.3-3.6,6.6-1,2.3-1.7,4.7-2.2,7.2s-.7,5-.7,7.5.3,5,.7,7.5,1.2,4.9,2.2,7.2c1,2.3,2.1,4.5,3.6,6.6,1.4,2.1,3,4,4.8,5.8,1.8,1.8,3.7,3.4,5.8,4.8,2.1,1.4,4.3,2.6,6.6,3.6,2.3,1,4.7,1.7,7.2,2.2s5,.7,7.5.7c2.5,0,5-.3,7.5-.8,2.5-.5,4.9-1.2,7.2-2.2,2.3-1,4.5-2.2,6.6-3.6,2.1-1.4,4-3,5.8-4.8s3.4-3.7,4.8-5.8c1.4-2.1,2.6-4.3,3.5-6.6,1-2.3,1.7-4.7,2.2-7.2.5-2.5.7-5,.7-7.5ZM151.8,369.5c0-1.1.2-2.2.7-3.3.4-1,1-2,1.8-2.8s1.7-1.4,2.8-1.9,2.1-.7,3.3-.7,2.2.2,3.3.7,2,1,2.8,1.9c.8.8,1.4,1.7,1.9,2.8.4,1,.6,2.1.6,3.3s-.2,2.2-.6,3.3c-.4,1-1,2-1.9,2.8-.8.8-1.7,1.4-2.8,1.9s-2.1.7-3.3.7-2.2-.2-3.3-.7c-1-.4-2-1-2.8-1.9-.8-.8-1.4-1.7-1.9-2.8-.4-1-.7-2.1-.7-3.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M49.3,365.3h64.2c1.9-23.5,23.1-43,46.8-42.7,23.7-.3,44.9,19.1,46.8,42.7h34.3v-76.9H2.4v29.9c0,1.5,0,3.1.2,4.6.2,1.5.4,3.1.7,4.6.3,1.5.7,3,1.1,4.5.4,1.5,1,2.9,1.6,4.3.6,1.4,1.2,2.8,2,4.2.7,1.4,1.5,2.7,2.4,4,.9,1.3,1.8,2.5,2.7,3.7,1,1.2,2,2.3,3.1,3.4,1.1,1.1,2.2,2.1,3.4,3.1,1.2,1,2.4,1.9,3.7,2.7,1.3.9,2.6,1.6,3.9,2.4,1.4.7,2.7,1.4,4.2,2,1.4.6,2.9,1.1,4.3,1.5,1.5.4,3,.8,4.5,1.1,1.5.3,3,.5,4.6.7,1.5.1,3.1.2,4.6.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M40.8,208h68.3c.6,0,1.1.1,1.6.3.5.2,1,.5,1.4.9.4.4.7.9.9,1.4s.3,1.1.3,1.6v32.7c0,.6-.1,1.1-.3,1.6s-.5,1-.9,1.4c-.4.4-.9.7-1.4.9s-1.1.3-1.6.3H40.8c-.6,0-1.1-.1-1.6-.3s-1-.5-1.4-.9c-.4-.4-.7-.9-.9-1.4s-.3-1.1-.3-1.6v-32.7c0-.6.1-1.1.3-1.6s.5-1,.9-1.4c.4-.4.9-.7,1.4-.9.5-.2,1.1-.3,1.6-.3Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M241.4,177.4H2.4v102.5h239.1v-102.5ZM121.9,245c0,.8,0,1.7-.3,2.5-.2.8-.4,1.6-.7,2.4-.3.8-.7,1.5-1.2,2.2s-1,1.4-1.6,1.9-1.2,1.1-1.9,1.6-1.4.9-2.2,1.2c-.8.3-1.6.6-2.4.7-.8.2-1.7.2-2.5.2H40.8c-.8,0-1.7,0-2.5-.2-.8-.2-1.6-.4-2.4-.7-.8-.3-1.5-.7-2.2-1.2s-1.4-1-1.9-1.6c-.6-.6-1.1-1.2-1.6-1.9-.5-.7-.9-1.4-1.2-2.2-.3-.8-.6-1.6-.7-2.4-.2-.8-.2-1.6-.2-2.5v-32.7c0-.8,0-1.7.2-2.5.2-.8.4-1.6.7-2.4.3-.8.7-1.5,1.2-2.2.5-.7,1-1.3,1.6-1.9.6-.6,1.2-1.1,1.9-1.6.7-.5,1.4-.9,2.2-1.2.8-.3,1.6-.6,2.4-.7.8-.2,1.7-.3,2.5-.3h68.3c.8,0,1.7,0,2.5.3.8.2,1.6.4,2.4.7.8.3,1.5.7,2.2,1.2.7.5,1.3,1,1.9,1.6.6.6,1.1,1.2,1.6,1.9s.9,1.4,1.2,2.2c.3.8.6,1.6.7,2.4.2.8.3,1.7.3,2.5v32.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M326.8,147.5v21.3h76.6c-.1-2.6-.4-5.1-.8-7.6-.4-2.5-.9-5.1-1.5-7.5-.6-2.5-1.4-4.9-2.2-7.4-.8-2.4-1.8-4.8-2.9-7.1-1.1-2.3-2.3-4.6-3.5-6.8s-2.7-4.4-4.2-6.5c-1.5-2.1-3.1-4.1-4.8-6-1.7-1.9-3.4-3.8-5.3-5.6-1.9-1.8-3.8-3.4-5.8-5-2-1.6-4.1-3.1-6.3-4.4-2.2-1.4-4.4-2.7-6.7-3.8-2.3-1.2-4.6-2.2-7-3.2-2.4-.9-4.8-1.8-7.3-2.5-2.5-.7-4.9-1.3-7.5-1.8-2.5-.5-5.1-.9-7.6-1.1-2.6-.2-5.1-.4-7.7-.4H83.5c-2.6,0-5.1.1-7.7.4-2.6.3-5.1.6-7.6,1.1-2.5.5-5,1.1-7.5,1.8-2.5.7-4.9,1.6-7.3,2.5-2.4,1-4.7,2-7,3.2-2.3,1.2-4.5,2.5-6.7,3.8-2.2,1.4-4.2,2.9-6.3,4.4-2,1.6-4,3.3-5.8,5-1.9,1.8-3.6,3.6-5.3,5.6-1.7,1.9-3.3,3.9-4.8,6-1.5,2.1-2.9,4.2-4.2,6.5-1.3,2.2-2.5,4.5-3.5,6.8-1.1,2.3-2,4.7-2.9,7.1s-1.6,4.9-2.2,7.4c-.6,2.5-1.1,5-1.5,7.5-.4,2.5-.6,5.1-.8,7.6h238.9v-21.3c0-1.4.1-2.8.4-4.2s.7-2.7,1.2-4c.5-1.3,1.2-2.5,2-3.7.8-1.2,1.7-2.2,2.7-3.2,1-1,2.1-1.9,3.2-2.7,1.2-.8,2.4-1.4,3.7-2,1.3-.5,2.6-.9,4-1.2,1.4-.3,2.8-.4,4.2-.4h42.7c1.4,0,2.8.1,4.2.4,1.4.3,2.7.7,4,1.2,1.3.5,2.5,1.2,3.7,2,1.2.8,2.2,1.7,3.2,2.7,1,1,1.9,2.1,2.7,3.2.8,1.2,1.4,2.4,2,3.7.5,1.3.9,2.6,1.2,4s.4,2.8.4,4.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M318.3,147.5c0-.8,0-1.7-.3-2.5-.2-.8-.4-1.6-.7-2.4-.3-.8-.7-1.5-1.2-2.2-.5-.7-1-1.3-1.6-1.9s-1.2-1.1-1.9-1.6-1.4-.9-2.2-1.2c-.8-.3-1.6-.6-2.4-.7-.8-.2-1.7-.3-2.5-.3h-42.7c-.8,0-1.7,0-2.5.3-.8.2-1.6.4-2.4.7-.8.3-1.5.7-2.2,1.2s-1.3,1-1.9,1.6c-.6.6-1.1,1.2-1.6,1.9s-.9,1.4-1.2,2.2c-.3.8-.6,1.6-.7,2.4-.2.8-.3,1.7-.3,2.5v217.7h68.3v-217.7ZM279.9,237.2c0,.6-.1,1.1-.3,1.6s-.5,1-.9,1.4-.9.7-1.4.9c-.5.2-1.1.3-1.6.3s-1.1-.1-1.6-.3c-.5-.2-1-.5-1.4-.9-.4-.4-.7-.9-.9-1.4s-.3-1.1-.3-1.6v-8.5c0-.6.1-1.1.3-1.6s.5-1,.9-1.4c.4-.4.9-.7,1.4-.9s1.1-.3,1.6-.3,1.1.1,1.6.3c.5.2,1,.5,1.4.9.4.4.7.9.9,1.4s.3,1.1.3,1.6v8.5Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M493.4,356.7h-21.4v-4.3c0-.8,0-1.7-.2-2.5-.2-.8-.4-1.6-.7-2.4-.3-.8-.7-1.5-1.2-2.2-.5-.7-1-1.4-1.6-1.9-.6-.6-1.2-1.1-1.9-1.6-.7-.5-1.4-.9-2.2-1.2-.8-.3-1.6-.6-2.4-.7-.8-.2-1.7-.3-2.5-.3s-1.7,0-2.5.3c-.8.2-1.6.4-2.4.7-.8.3-1.5.7-2.2,1.2s-1.3,1-1.9,1.6-1.1,1.2-1.6,1.9-.9,1.4-1.2,2.2c-.3.8-.6,1.6-.7,2.4-.2.8-.3,1.7-.3,2.5v4.3h-62.7c3.1-2.2,5.9-4.7,8.4-7.5,2.5-2.8,4.6-5.9,6.4-9.3,1.7-3.3,3.1-6.8,4-10.5.9-3.7,1.4-7.4,1.4-11.2v-29.9h-76.9v76.9h128.1v29.9c0,.6.1,1.1.3,1.6.2.5.5,1,.9,1.4.4.4.9.7,1.4.9s1.1.3,1.6.3,1.1-.1,1.6-.3,1-.5,1.4-.9c.4-.4.7-.9.9-1.4.2-.5.3-1.1.3-1.6v-29.9h29.9c.6,0,1.1-.1,1.6-.3s1-.5,1.4-.9c.4-.4.7-.9.9-1.4s.3-1.1.3-1.6-.1-1.1-.3-1.6-.5-1-.9-1.4c-.4-.4-.9-.7-1.4-.9s-1.1-.3-1.6-.3Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeCaravane);
export default __webpack_public_path__ + "static/media/Icone-caravane.b46ff52c0262a3728b36202b7e58840a.svg";
export { ForwardRef as ReactComponent };